import { ComponentProps } from 'react';
import { Optional } from 'ts-toolbelt/out/Object/Optional';
import { Photos } from '@frontend/photos';
import { Avatar, CircularAvatarGroup, AvatarProps } from '@frontend/design-system';

type AvatarSwitcherProps = Optional<ComponentProps<typeof Photos.ContactProfilePhoto>, 'personId'> & {
  groupAvatars?: AvatarProps[];
  groupMessagingEnabled?: boolean;
};

export const AvatarSwitcher = ({
  personId,
  groupAvatars,
  groupMessagingEnabled,
  locationId,
  ...rest
}: AvatarSwitcherProps) => {
  if (groupMessagingEnabled && groupAvatars?.length) {
    return <CircularAvatarGroup avatars={groupAvatars} size={'small'} />;
  }

  if (!personId) {
    return <Avatar {...rest} />;
  }

  if (rest.disableClick && rest.onClick) {
    return (
      <div role='button' onClick={rest.onClick} style={{ cursor: 'pointer' }}>
        <Photos.ContactProfilePhoto personId={personId} {...rest} />
      </div>
    );
  }

  return <Photos.ContactProfilePhoto personId={personId} {...rest} />;
};
